<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers.filter(a => a.show || a.active)"
          :items="items"
          :footer-props="datatable_footer"
          :loading="loading"
          no-data-text="Нет данных для отображения"
          @click:row="open"
        >
          <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
          </template>
          <template v-slot:top>
            <v-card flat>
              <v-card-text>
                <v-row
                  dense
                  align="center"
                >
                  <v-col
                    cols="12"
                    sm="2"
                  >
                    <v-btn
                      color="primary"
                      outlined
                      @click="$refs.filter.open()"
                    >
                      <v-icon class="ml-3">
                        mdi-filter-variant
                      </v-icon>
                      <span class="mx-3">Фильтры</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <v-btn
                      color="primary"
                      @click="$router.push($route.path.replace(/list$/, 'create'))"
                    >
                      <v-icon class="ml-3">
                        mdi-plus
                      </v-icon>
                      <span class="mx-3">Создать визит</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    class="d-sm-flex justify-end"
                  >
                    <v-btn
                      color="secondary"
                      outlined
                      @click="reset(); load()"
                    >
                      <v-icon class="ml-3">
                        mdi-refresh
                      </v-icon>
                      <span class="mx-3">Обновить</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="1"
                    class="d-sm-flex justify-center"
                  >
                    <v-icon
                      medium
                      class="icon-table"
                      @click="openSkudHeaders()"
                    >
                      mdi-table-cog
                    </v-icon>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
          <template v-slot:item.state_text="{item}">
            <v-chip
              small
              :color="item.state_color"
              dark
            >
              {{ item.state_text }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{item}">
            <skud-actions-menu>
              <v-list-item @click="open(item)">
                <v-list-item-content>
                  Открыть
                </v-list-item-content>
              </v-list-item>
            </skud-actions-menu>
          </template>
        </v-data-table>
        <div
          v-if="next_cursor_visit_id"
          class="text-center mt-3"
        >
          <v-btn
            color="primary"
            outlined
            :loading="loading"
            @click="load()"
          >
            Загрузить ещё
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <skud-filter-dialog
      ref="filter"
      :fields="filter_fields"
      storage-key="skud.visit"
      @apply="onFilterApply"
    />
    <v-dialog
      v-model="dialog_headers.show"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Настройка столбцов</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items-per-page="5"
            dense
            :items="headers.filter(a => !a.show)"
            :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
            :footer-props="datatable_footer"
            no-data-text="Нет данных для отображения"
          >
            <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
            <template v-slot:item.active_temp="{item}">
              <v-checkbox v-model="item.active_temp" />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="saveSkudHeaders('skud_visit')"
          >
            <span class="mx-4">Сохранить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_headers.show = false"
          >
            <span class="mx-4">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Список визитов СКУД: keyset-пагинация (cursor_visit_id) + клиентская таблица.
// Client-scope: все места клиента, имена мест — из справочника vending (skud-places-service).
// ponytail: сортировка/пагинация только по загруженным; серверный paging — когда бэкенд добавит page/total.
import { headersMixin } from '@/views/skud/shared/modules/headers-mixin'
import { SkudVisitService } from '@/views/skud/shared/services/skud-visit-service'
import { loadPlaces, placeName } from '@/views/skud/shared/services/skud-places-service'
import { VisitState, enumOptions } from '@/views/skud/shared/models/enums'
import SkudFilterDialog from '@/views/skud/components/SkudFilterDialog.vue'
import SkudActionsMenu from '@/views/skud/components/SkudActionsMenu.vue'

export default {
  name: 'SkudVisitList',
  components: { SkudFilterDialog, SkudActionsMenu },
  mixins: [headersMixin],
  data () {
    return {
      service: null,
      items: [],
      loading: false,
      next_cursor_visit_id: null,
      filters: {},
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageOptions: [5, 10, 15, 30, 50]
      },
      filter_fields: {
        main: {
          index: 0,
          name: 'Визит',
          data: [
            { name: 'Состояние', field: 'state', type: 'select', select: enumOptions(VisitState) }
          ]
        }
      },
      headers: [
        { value: 'actions', text: 'Действия', show: true, sortable: false },
        { value: 'public_id', text: 'ID визита', show: true, active: true, active_temp: true },
        { value: 'title', text: 'Заголовок', show: false, active: true, active_temp: true },
        { value: 'state_text', text: 'Состояние', show: false, active: true, active_temp: true },
        { value: 'starts_at', text: 'Начало', show: false, active: true, active_temp: true },
        { value: 'ends_at', text: 'Окончание', show: false, active: true, active_temp: true },
        { value: 'side_text', text: 'Сторона', show: false, active: true, active_temp: true },
        { value: 'from_place_name', text: 'Откуда', show: false, active: true, active_temp: true },
        { value: 'to_place_name', text: 'Куда', show: false, active: true, active_temp: true },
        { value: 'participants_count', text: 'Участники', show: false, active: true, active_temp: true },
        { value: 'purpose', text: 'Цель', show: false, active: true, active_temp: true },
        { value: 'reject_reason', text: 'Причина отказа', show: false, active: true, active_temp: true }
      ]
    }
  },
  mounted () {
    this.service = new SkudVisitService()
    this.setDefaultSkudHeaders(this.$store.state.user.skud_visit_headers)
    this.filters = this.$refs.filter.current()
    loadPlaces().then(() => this.load())
  },
  methods: {
    reset () {
      this.items = []
      this.next_cursor_visit_id = null
    },
    onFilterApply (values) {
      this.filters = values
      this.reset()
      this.load()
    },
    async load () {
      this.loading = true
      const params = { limit: 50 }
      if (this.filters.state !== undefined) params.state = this.filters.state
      if (this.next_cursor_visit_id) params.cursor_visit_id = this.next_cursor_visit_id
      const res = await this.service.getVisits(null, params)
      this.loading = false
      if (!res) {
        this.$store.commit('snackbar', 'Ошибка при получении данных')
        return
      }
      this.items = this.items.concat(res.items.map(x => Object.assign({}, x, {
        from_place_name: placeName(x.from_place_id),
        to_place_name: placeName(x.to_place_id)
      })))
      this.next_cursor_visit_id = res.next_cursor_visit_id
    },
    open (item) {
      this.$router.push({
        path: this.$route.path.replace(/list$/, 'view'),
        query: { id: item.visit_id, place: item.side === 'to' ? item.to_place_id : item.from_place_id }
      })
    }
  }
}
</script>

<style scoped>
.icon-table {
  height: 30px;
  width: 30px;
  margin-top: 3px;
  margin-left: 8px;
  color: grey;
}
.icon-table:hover {
  color: #315bbf;
}
</style>
